<template>
  <div>
    <ShowMore showheight="200px">
      <div class="dht-items">
        <div v-for="(item, key) in items" :key="key" class="dht-item">
          <ImageView v-if="item.image" :src="item.image" :desc="item.imageDesc"></ImageView>
          <AudioView v-if="item.audio" :src="item.audio"></AudioView>
          <pinyin :text="item.text" :pinyin="item.pinyin"></pinyin>
        </div>
      </div>
    </ShowMore>
  </div>
</template>

<script>
import ImageView from './../../ImageView'
import AudioView from './../../AudioView'
import pinyin from './../../PinyinPreview'
import ShowMore from '../../ShowMore.vue'

export default {
  name: 'DhtView',
  components: { pinyin, ImageView, AudioView, ShowMore },
  props: {
    type: {
      type: Object,
      default: () => {
        return {}
      }
    },
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    items () {
      return this.entity.items.map(n => {
        let item = Object.assign({}, n)
        if (item.masks) {
          if (item.text) {
            item.text = this.formatMaskText(item.text, this.masks)
          }
          if (item.pinyin) {
            item.pinyin = this.formatMaskText(item.pinyin, this.masks)
          }
        }
        return item
      })
    }
  },
  methods: {
    formatMaskText(text, masks) {
      let parts = text.split(' ')
      masks.forEach(n => {
        parts[n] = '**' + parts[n] + '**'
      })
      return parts.join(' ')
    }
  }
}
</script>
